import React, { useState, useContext, useEffect } from "react";
import { Button, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import CircularProgress from "@mui/material/CircularProgress";
import { AuthContext } from "../../context/AuthContext";
import { baseUrl } from "../../baseUrl";
import axios from "axios";

const DeleteOrderType = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [handler, setHandler] = useState(false);
  const auth = useContext(AuthContext);
  const dispatch = useDispatch();
  const orderTypeId = props.id;
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [totalItems, setTotalItems] = useState(0);

  //order search handler
  async function sendRequest() {
    setIsLoading(true);
    axios
      .post(
        "/api/v1/laboratorys/search-orders",
        {
          orderTypeId: orderTypeId,
          ascending: "DESC",
          page: 1,
          rowCount: 15,
          sort: "startDate",
          status: 0,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        setTotalItems(response.data.data.totalItem);
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
        props.close();
        const messages =
          e.response.data.data.length > 0
            ? e.response.data.data
            : e.response.data.message.message;
        Array.isArray(messages)
          ? messages.map((message) => {
              enqueueSnackbar(message, { variant: "error" });
            })
          : enqueueSnackbar(messages, { variant: "error" });
      });
  }
  useEffect(() => {
    sendRequest();
  }, [orderTypeId]);

  const deleteHandler = async (event) => {
    try {
      setIsLoading(true);
      const response = await fetch(
        baseUrl + "/api/v1/laboratorys/delete-orderType",
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
          body: JSON.stringify({
            id: props.id,
          }),
        }
      );
      const responseData = await response.json();
      if (!response.ok) {
        throw new Error(responseData.message);
      } else {
        enqueueSnackbar(responseData.message.message, { variant: "success" });
      }
      setIsLoading(false);
      dispatch({
        type: "update_order_types",
      });
    } catch (err) {
      setIsLoading(false);
      err && enqueueSnackbar(err.message, { variant: "error" });
    }
    props.close();
  };

  if (isLoading) {
    return (
      <div style={{ justifyContent: "center", display: "flex" }}>
        <CircularProgress color="inherit" />
      </div>
    );
  }
  return (
    <div>
      <Typography variant="h6" component="h2">
        هشدار
      </Typography>
      <Typography id="modal-modal-description" sx={{ mt: 2 }}>
        {totalItems > 0 ? (
          <>
            آیا مطمئنید می خواهید این نوع کار را حذف کنید ؟
            <br />
            تعداد سفارش موجود از این نوع کار: {totalItems}
          </>
        ) : (
          "آیا مطمئنید می خواهید این نوع کار را حذف کنید ؟"
        )}
      </Typography>
      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid xs={6}>
          <Button
            fullWidth
            color="error"
            variant="contained"
            onClick={deleteHandler}
            disabled={totalItems > 0}
          >
            بله
          </Button>
        </Grid>
        <Grid xs={6}>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={props.close}
          >
            خیر
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default DeleteOrderType;
